"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addShippingOffer = addShippingOffer;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
async function addShippingOffer({
  client,
  globalShoppingShippingChoiceDto,
  sessionId,
  tenant
  // placement,
  // referer,
}) {
  const headers = {
    // [PLACEMENT]: placement,
    [_fetching.TENANT_CONTEXT]: tenant
    // 'x-referer': referer,
  };
  return (0, _globalApiClientReact.createShoppingSessionShippingJokerChoice)(client, sessionId, globalShoppingShippingChoiceDto, headers);
}
